export default function Services() {
    return (
        <>
        <div className="container-fluid row bg-primary" style={{height:'250px'}}>
            <div className="col-lg-1"></div>
            <div className="col-lg display-2 text-white p-5 ms-5"><span className="headText">Our Services</span></div>
            <div className="col-lg-3 text-white p-5 ms-5"><a className="text-white" href="http://jmsinsuranceconsulting.com/" target='_blank' rel="noreferrer">Insurance</a></div>
        </div>

        <div className="container-fluid row mt-5 mb-5">
            <div className="col-lg-2"></div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">ACCOUNTING SERVICES <br /></div>
                Small Business Accounting <br />
                Bookkeeping Services <br />
                Generate an Income Statement <br />
                Generate a Balance Sheet <br />
                Reconcile Your Bank Account <br />
                Clean up Your General Ledger <br />
            </div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">ACCOUNTING SOFTWARE <br /></div>
                Quickbooks Installation and Setup <br />
                QuickBooks Training <br />
                Quick Answers <br />
                Quick Tune-up <br />
                <br />
                <br />
            </div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">PAYROLL <br /></div>
                Weekly, Biweekly, Semi Monthly or Monthly <br />
                Payroll Taxes Payments <br />
                Quarterly Reporting - IRS and State <br />
                Annual W2's <br />
                Annual 1099 <br />
                Payroll After the fact <br />
                
            </div>
            <div className="col-lg-2"></div>
        </div>

        <div className="container-fluid row h-100">
            <div className="col-lg-2"></div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">BUSINESS SERVICES <br /></div>
                Tax Planning<br />
                Tax Preparation<br />
                Tax Credits<br />
                Payroll Tax Penalties<br />
                International Tax<br />
                <br />
            </div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">FINANCES <br /></div>
                Financial Reporting & Assurance<br />
                Audit, Review and Compilation<br />
                Overhead Rate Audits and FAR Compliance<br />
                Bank Financing<br />
                Internal Controls<br />
                <br />
            </div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">CONSULTATION <br /></div>
                New Company Formation<br />
                Advisory Services<br />
                Business Planning<br />
                Succession Planning<br />
                <br />
                <br />
            </div>
            <div className="col-lg-2"></div>
        </div>

        <div className="container-fluid row mt-5 mb-5">
            <div className="col-lg-2"></div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">INDIVIDUALS SERVICES <br /></div>
                <div className="fw-bold">Taxes <br /></div>
                Taxes - Federal and State<br />
                Tax Planning<br />
                Tax Consultation<br />
                International Taxes<br />
                <br />
            </div>
            <div className="col-lg-2"></div>
        </div>

        <div className="container-fluid row mt-5 mb-5">
            <div className="col-lg-2"></div>
            <div className="col-lg text-dark text-center">
                <div className="fw-bold">INDUSTRIES SERVICED <br /></div>
                <div className="lead">Professional Services | Construction | Real Estate | Non Profit | Manufacturing<br /></div>
                <br />
            </div>
            <div className="col-lg-2"></div>
        </div>
        </>
    );
}